import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=05c2f7b2&scoped=true"
import script from "./Rankings.vue?vue&type=script&lang=ts&setup=true"
export * from "./Rankings.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Rankings.vue?vue&type=style&index=0&id=05c2f7b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c2f7b2",
  null
  
)

export default component.exports